import { useState, useEffect } from "react";

const MAX_INTENTOS = 3;

const RESULTADOS = [
    { key: "sin_respuesta",     icon: "bi-telephone-x",       label: "Sin respuesta definitiva",  color: "var(--gris-suave)" },
    { key: "no_quiere",         icon: "bi-ban",               label: "No quiere más llamadas",    color: "var(--rojo-error)" },
    { key: "pte_identidad",     icon: "bi-person-vcard",      label: "Pendiente identidad",       color: "var(--azul-bootstrap-cta)" },
    { key: "publicado",         icon: "bi-check-circle",      label: "Se publicó correctamente",  color: "var(--verde-bootstrap)" },
];

export const RESULTADO_CONFIG = {
    sin_respuesta: { label: "Sin respuesta",      color: "var(--gris-suave)", icon: "bi-telephone-x"      },
    no_quiere:     { label: "No llamar más",      color: "var(--rojo-error)", icon: "bi-ban"              },
    pte_identidad: { label: "Pdte. identidad",    color: "var(--azul-bootstrap-cta)", icon: "bi-person-vcard"     },
    publicado:     { label: "Publicado ✓",        color: "var(--verde-bootstrap)", icon: "bi-check-circle-fill" },
};

function colorIntento(n) {
    if (n >= MAX_INTENTOS) return "var(--rojo-error)";
    if (n === 2)           return "var(--naranja-mapa)";
    return "var(--dorado-oscuro)";
}

function ModalLlamarUsuario({ show, onClose, onGuardar, guardando, intentosActuales = 0, resultadoActual = "", notaActual = "" }) {
    const [intentos,  setIntentos]  = useState(intentosActuales);
    const [resultado, setResultado] = useState(resultadoActual);
    const [nota,      setNota]      = useState(notaActual);

    useEffect(() => {
        if (show) {
            setIntentos(intentosActuales);
            setResultado(resultadoActual);
            setNota(notaActual);
        }
    }, [show, intentosActuales, resultadoActual, notaActual]);

    if (!show) return null;

    const color = intentos > 0 ? colorIntento(intentos) : "var(--azul-bootstrap-cta)";
    const nuevosIntentos = intentos - intentosActuales;

    return (
        <>
            <div className="modal-backdrop fade show" style={{ zIndex: 1050 }} onClick={onClose} />
            <div className="modal fade show d-block" style={{ zIndex: 1055 }} tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 430 }}>
                    <div className="modal-content rounded-4 border-0 shadow-lg">

                        <div className="modal-header border-0 pb-1">
                            <h5 className="modal-title fw-bold fs-6">
                                <i className="bi bi-telephone-fill me-2 text-success"></i>Registrar llamada
                            </h5>
                            <button type="button" className="btn-close" onClick={onClose} />
                        </div>

                        <div className="modal-body pt-2 pb-3">

                            {/* Contador de intentos */}
                            <div className="rounded-4 p-3 mb-4 d-flex align-items-center gap-3"
                                style={{ background: intentos > 0 ? `${color}12` : "rgba(var(--azul-bootstrap-cta-rgb), 0.06)", border: `1.5px solid ${intentos > 0 ? color : "var(--color-border)"}` }}>
                                <div className="text-center flex-shrink-0" style={{ minWidth: 56 }}>
                                    <div className="fw-bold" style={{ fontSize: "2rem", lineHeight: 1, color: intentos > 0 ? color : "var(--gris-suave)" }}>
                                        {intentos}
                                    </div>
                                    <div className="text-muted" style={{ fontSize: "0.72rem" }}>
                                        {intentos === 1 ? "intento" : "intentos"}
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                    <div className="text-muted mb-2" style={{ fontSize: "0.82rem" }}>
                                        {intentos === 0
                                            ? "Aún no se ha registrado ninguna llamada."
                                            : intentos >= MAX_INTENTOS
                                                ? `Se alcanzaron ${MAX_INTENTOS} intentos sin respuesta.`
                                                : `Quedan ${MAX_INTENTOS - intentos} intento${MAX_INTENTOS - intentos !== 1 ? "s" : ""} antes de marcar sin respuesta.`}
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-sm rounded-3 fw-semibold d-inline-flex align-items-center gap-2"
                                        style={{ background: color, color: "var(--blanco)", fontSize: "0.82rem" }}
                                        onClick={() => setIntentos(n => n + 1)}
                                    >
                                        <i className="bi bi-telephone-plus"></i>
                                        {intentos === 0 ? "Registrar llamada" : "Registrar otro intento"}
                                        {nuevosIntentos > 0 && (
                                            <span className="badge rounded-pill" style={{ background: "rgba(var(--blanco-rgb), 0.3)", fontSize: "0.7rem" }}>
                                                +{nuevosIntentos}
                                            </span>
                                        )}
                                    </button>
                                </div>
                            </div>

                            {/* Resultado final */}
                            <p className="text-muted fw-semibold mb-2" style={{ fontSize: "0.8rem" }}>
                                Resultado final <span className="fw-normal">(opcional)</span>
                            </p>
                            <div className="d-flex flex-column gap-2 mb-4">
                                {RESULTADOS.map(({ key, icon, label, color: c }) => {
                                    const activo = resultado === key;
                                    const deshabilitado = key === "sin_respuesta" && intentos < MAX_INTENTOS;
                                    return (
                                        <button
                                            key={key}
                                            type="button"
                                            className="btn text-start rounded-3 d-flex align-items-center gap-3 px-3 py-2"
                                            style={{
                                                border: `1.5px solid ${activo ? c : "var(--color-border)"}`,
                                                background: activo ? `${c}15` : "transparent",
                                                color: activo ? c : deshabilitado ? "var(--gris-adb5bd)" : "var(--gris-495057)",
                                                opacity: deshabilitado ? 0.5 : 1,
                                                transition: "all 0.15s",
                                                cursor: deshabilitado ? "not-allowed" : "pointer",
                                            }}
                                            onClick={() => !deshabilitado && setResultado(activo ? "" : key)}
                                            title={deshabilitado ? `Disponible después de ${MAX_INTENTOS} intentos sin respuesta` : ""}
                                        >
                                            <i className={`bi ${icon} fs-5 flex-shrink-0`}></i>
                                            <span className="flex-grow-1" style={{ fontSize: "0.88rem" }}>
                                                <span className="fw-semibold">{label}</span>
                                                {deshabilitado && (
                                                    <span className="d-block" style={{ fontSize: "0.72rem", opacity: 0.7 }}>
                                                        Disponible tras {MAX_INTENTOS} intentos
                                                    </span>
                                                )}
                                            </span>
                                            {activo && <i className="bi bi-check-circle-fill ms-auto flex-shrink-0"></i>}
                                        </button>
                                    );
                                })}
                            </div>

                            {/* Nota */}
                            <div>
                                <label className="form-label text-muted fw-semibold mb-1" style={{ fontSize: "0.8rem" }}>
                                    Nota adicional <span className="fw-normal">(opcional)</span>
                                </label>
                                <textarea
                                    className="form-control rounded-3"
                                    rows={2}
                                    placeholder="Escribe si ocurrió algo relevante..."
                                    value={nota}
                                    onChange={e => setNota(e.target.value)}
                                    style={{ fontSize: "0.85rem", resize: "none" }}
                                />
                            </div>
                        </div>

                        <div className="modal-footer border-0 pt-0 gap-2">
                            <button type="button" className="btn btn-outline-secondary rounded-3 btn-sm" onClick={onClose} disabled={guardando}>
                                Cancelar
                            </button>
                            <button
                                type="button"
                                className="btn btn-success rounded-3 btn-sm fw-semibold px-4"
                                onClick={() => onGuardar(intentos, resultado, nota)}
                                disabled={guardando || (intentos === intentosActuales && resultado === resultadoActual && nota === notaActual)}
                            >
                                {guardando
                                    ? <><span className="spinner-border spinner-border-sm me-1" />Guardando...</>
                                    : <><i className="bi bi-check2 me-1"></i>Guardar</>
                                }
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default ModalLlamarUsuario;
